import moment from 'moment';
import { mapGetters } from 'vuex';
import { HEALTH_STATUS } from '@/constants/businessProcess/constants';

export default {
  name: 'EcsBusinessProcessHealthMixins',

  computed: {
    ...mapGetters('BUSINESS_PROCESSES', [
      'supervisedBusinessProcesses',
      'businessProcessHealthConfigurationTemplates',
      'getBusinessProcessHealthConfiguration',
      'getActiveBusinessProcessHealthThreshold'
    ]),

    businessProcess() {
      return this.supervisedBusinessProcesses.find(
        businessProcess => businessProcess.businessProcessId === this.businessProcessId
      );
    },

    kpis() {
      const activeBPHealthThreshold = this.getActiveBusinessProcessHealthThreshold(this.businessProcessId);
      return activeBPHealthThreshold ? activeBPHealthThreshold.businessProcessKpis : {};
    },

    businessProcessHealthConfiguration() {
      const currentHealthConfiguration = this.getBusinessProcessHealthConfiguration(this.businessProcessId);
      return currentHealthConfiguration
        ? this.businessProcessHealthConfigurationTemplates.find(
            configuration => configuration._id === currentHealthConfiguration.configurationId
          )
        : null;
    },

    criticalKpi() {
      return this.criticalKpis.length ? this.criticalKpis[0] : null;
    },

    criticalKpis() {
      const healthConfiguration = this.businessProcessHealthConfiguration;
      if (!healthConfiguration || !this.kpis) {
        return [];
      }

      return healthConfiguration.kpis
        .map(id => this.kpis[id])
        .filter(kpi => kpi && kpi.status)
        .sort((kpi1, kpi2) => kpi1.status - kpi2.status)
        .slice(0, 3);
    }
  },

  methods: {
    getKpiColor(status) {
      let result = 'unset';

      switch (status) {
        case HEALTH_STATUS.Warning:
          result = 'var(--v-warning-base)';
          break;
        case HEALTH_STATUS.Danger:
          result = 'var(--v-error-base)';
          break;
      }

      return result;
    },

    getHealthColor(status) {
      let result = null;

      switch (status) {
        case HEALTH_STATUS.Good:
          result = 'var(--v-success-lighten1)';
          break;
        case HEALTH_STATUS.Warning:
          result = 'var(--v-warning-base)';
          break;
        case HEALTH_STATUS.Danger:
          result = 'var(--v-error-base)';
          break;
      }

      return result;
    },

    getHealthStatusName(status) {
      let result = null;

      switch (status) {
        case HEALTH_STATUS.Good:
          result = 'good';
          break;
        case HEALTH_STATUS.Warning:
          result = 'warning';
          break;
        case HEALTH_STATUS.Danger:
          result = 'danger';
          break;
      }

      return result;
    },

    getFormattedValue(value, type) {
      if (type === 'TimeSpan') {
        const timeFormat = value.hours() ? 'H:m:ss' : 'm:ss';
        return moment(value).isValid() ? value.format(timeFormat) : '';
      } else if (value && !Number.isInteger(value)) {
        return value.toFixed(2);
      } else {
        return value;
      }
    }
  }
};
